import type { AppLanguage } from '@/i18n/types'
import { LANGUAGE_INTL_LOCALE } from '@/i18n/types'

export function formatDateTime(
  value: string | number | Date,
  language: AppLanguage,
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = value instanceof Date ? value : new Date(value)
  const locale = LANGUAGE_INTL_LOCALE[language]
  return date.toLocaleString(locale, options)
}

export function formatDate(
  value: string | number | Date,
  language: AppLanguage,
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = value instanceof Date ? value : new Date(value)
  const locale = LANGUAGE_INTL_LOCALE[language]
  return date.toLocaleDateString(locale, options)
}

export function formatTime(
  value: string | number | Date,
  language: AppLanguage,
  options?: Intl.DateTimeFormatOptions,
): string {
  const date = value instanceof Date ? value : new Date(value)
  const locale = LANGUAGE_INTL_LOCALE[language]
  return date.toLocaleTimeString(locale, options)
}
